const NavFacebookIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.9187 2.66675H10.0801C5.6464 2.66675 2.66675 5.78675 2.66675 10.4281V21.572C2.66675 26.2134 5.6464 29.3334 10.0801 29.3334H15.9495C15.9467 29.3039 15.9313 29.2773 15.9313 29.2464V19.6043H14.2976C13.7166 19.6043 13.245 19.1327 13.245 18.5517C13.245 17.9706 13.7166 17.499 14.2976 17.499H15.9313V15.8008C15.9313 13.0373 18.1811 10.7903 20.946 10.7903H22.3552C22.9362 10.7903 23.4078 11.2618 23.4078 11.8429C23.4078 12.4239 22.9362 12.8955 22.3552 12.8955H20.946C19.3418 12.8955 18.0366 14.198 18.0366 15.8008V17.499H21.6829C22.2639 17.499 22.7355 17.9706 22.7355 18.5517C22.7355 19.1327 22.2639 19.6043 21.6829 19.6043H18.0366V29.2464C18.0366 29.2773 18.0225 29.3039 18.0197 29.3334H21.9173C26.3524 29.3334 29.3334 26.2134 29.3334 21.572V10.4281C29.3334 5.78675 26.3538 2.66675 21.9187 2.66675Z"
        fill="url(#paint0_linear_15183_166101)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_15183_166101"
          x1="16.0001"
          y1="2.66675"
          x2="16.0001"
          y2="29.3334"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#89B8F0" />
          <stop offset="1" stopColor="#165BAD" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default NavFacebookIcon
